import { render } from "./BannerSec2.vue?vue&type=template&id=53b764aa"
import script from "./BannerSec2.vue?vue&type=script&lang=js"
export * from "./BannerSec2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__